import {Vue} from "ui.vue";

let MapMixin = {
	data: function () {
		return {

		}
	},
	computed: {
		locMixin() {
			return Vue.getFilteredPhrases("CITRUS_MAP_MIXIN_");
		}
	},
	methods: {
		showMap: function(point) {
			if (!point.coord && !point.address.length) {
				throw new Error('Point should have a coord or address field')
			}

			$.magnificPopup.open({
				items: {
					src: '<div class="citrus-objects-map" id="magnificPopupMap" style="width: 100%;height: 100%;"></div>',
				},
				mainClass: 'full-screen-map mfp-with-zoom',
				alignTop: false,
				closeOnContentClick: false,
				callbacks: {
					open: function () {
						$().citrusObjectsMap({
							id: 'magnificPopupMap',
							items: [point],
							controls: ['largeMapDefaultSet'],
							collapseButton: false,
							onError: function () {
								console.log('map error');
								this.closeMap();
							},
							onEmptyObject: function () {
								$('#magnificPopupMap').html('No item');
								setTimeout(this.closeMap, 400);
							}
						})
					}
				}
			});
		},
		closeMap: function() {
			return $.magnificPopup.instance && $.magnificPopup.instance.close();
		},
	}
};

export {MapMixin};

